export default "__VITE_ASSET__DOIxdomc__"